import _import from './config'

export default {
    path: 'student',
    component: {
        template: '<router-view :key="$route.fullPath"/>'
    },
    name: 'student',
    redirect: '/student/list',
    children: [
        {
            path: 'list',
            component: _import('student/list'),
            name: 'list',
            meta: {
                auth: true
            }
        }, {
            path: 'score',
            component: _import('student/score'),
            name: 'score',
            meta: {
                auth: true
            }
        }, {
            path: 'scorestatistics',
            component: _import('student/scoreStatistics'),
            name: 'scorestatistics',
            meta: {
                auth: true
            }
        }, {
            path: 'audition',
            component: _import('student/audition'),
            name: 'audition',
            meta: {
                auth: true
            }
        }, {
            path: 'studentpersonal',
            component: _import('student/studentPage'),
            name: 'studentpersonal',
            meta: {
                auth: true
            }
        }, {
            path: 'jdxkdata',
            component: _import('student/jdxkData'),
            name: 'jdxkdata',
            meta: {
                auth: true
            }
        }, {
            path: 'xkdtdata',
            component: _import('student/xkdtData'),
            name: 'xkdtdata',
            meta: {
                auth: true
            }
        }, {
            path: 'graduate',
            component: _import('student/graduate'),
            name: 'graduate',
            meta: {
                auth: true
            }
        }, {
            path: 'purchaseRecord',
            component: _import('student/purchaseRecord'),
            name: 'purchaseRecord',
            meta: {
                auth: true
            }
        }, {
            path: 'reduceProductRecord',
            component: _import('student/reduceProductRecord'),
            name: 'reduceProductRecord',
            meta: {
                auth: true
            }
        }, {
            path: 'multiCampusRecord',
            component: _import('student/multiCampusRecord'),
            name: 'multiCampusRecord',
            meta: {
                auth: true
            }
        },  {
            path: 'studentstatuslog',
            component: _import('student/studentStatusLog'),
            name: 'studentstatuslog',
            meta: {
                auth: true
            }
        }
    ]
}


// WEBPACK FOOTER //
// ./src/router/student.js